import React from "react";

function Wave() {
  return (
    <>
    <div style={{ backgroundColor: "white" }}>
      <svg viewBox="0 0 1320 300" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
        {/* No white path now */}
        <path
          fill="#E89897"
          fillOpacity="0.5"
          d="
            M0, 120
            C220, 50, 440, 50, 660, 120
            C880, 180, 1100, 180, 1320, 120
            L1320 300
            L0 300
            Z
          "
        />
        <path
          fill="#FFB284"
          fillOpacity="0.5"
          d="
            M0, 100
            C220, 20, 440, 20, 660, 100
            C880, 160, 1100, 160, 1320, 100
            L1320 300
            L0 300
            Z
          "
        />
      </svg>
    </div>
    <div style={{ backgroundColor: "#F9BEA6", height: "200px" }}>
    </div>
    </>
  );
}

export default Wave;
